"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionDataType = void 0;
/**
 * Defines supported region types.
 */
var RegionDataType;
(function (RegionDataType) {
    RegionDataType["Point"] = "point";
    RegionDataType["Rect"] = "rect";
    RegionDataType["Polyline"] = "polyline";
    RegionDataType["Polygon"] = "polygon";
    RegionDataType["Path"] = "Path";
})(RegionDataType = exports.RegionDataType || (exports.RegionDataType = {}));
//# sourceMappingURL=RegionDataType.js.map